import { render } from "./Comic.vue?vue&type=template&id=7ca9a5f4"
import script from "./Comic.vue?vue&type=script&lang=js"
export * from "./Comic.vue?vue&type=script&lang=js"

import exportComponent from "/home/federico/Progetti/PizzaReader/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__